import { mapGetters, mapState } from 'vuex'
import { changeToArr } from '@/utils/utils'
import i18n from '@/locales'

export default {
  computed: {
    ...mapGetters(['l3PermissionEnable', 'scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_574'),
        action: obj => {
          if (obj.provider.toLowerCase() === 'google') {
            const newWindow = window.open()
            newWindow.opener = null
            newWindow.location = 'https://console.cloud.google.com/'
            newWindow.target = '_black'
            return
          }
          new this.$Manager('cloudsupplier_customers').getSpecific({
            id: obj.id,
            spec: 'login',
          }).then(res => {
            const newWindow = window.open()
            newWindow.opener = null
            newWindow.location = res.data.data.url
            newWindow.target = '_black'
          })
        },
        meta: (obj) => {
          let validate = true
          let tooltip = ''
          if (this.scope !== 'domain') validate = false
          if (obj.status === 'certified' || obj.status === 'certificating' || obj.status === 'unknown') {
            validate = false
          }
          if (this.customer.certified_status !== 'certified') {
            validate = false
            tooltip = i18n.t('scope.text_549')
          }
          return {
            validate,
            tooltip,
          }
        },
      },
      {
        label: i18n.t('scope.text_575'),
        actions: obj => {
          const ownerDomain = this.$store.getters.isAdminMode || obj.domain_id === this.$store.getters.userInfo.projectDomainId
          const privateBillAction = []
          return privateBillAction.concat([
            {
              label: i18n.t('scope.text_547'),
              permission: 'cloudaccounts_perform_sync',
              action: (obj) => {
                new this.$Manager('cloudaccounts').performAction({
                  id: obj.cloudaccount_id,
                  action: 'sync',
                  data: {
                    full_sync: true,
                    force: true,
                  },
                })
              },
              meta: (obj) => this.syncPolicy(obj),
            },
            {
              label: i18n.t('scope.text_524'),
              permission: 'cloudaccounts_perform_sync',
              action: () => {
                new this.$Manager('cloudaccounts').performAction({
                  id: obj.cloudaccount_id,
                  action: 'sync',
                })
              },
              meta: () => {
                let tooltip
                if (!obj.enabled_status) tooltip = i18n.t('scope.text_526')
                if (obj.enable_auto_sync) tooltip = i18n.t('scope.text_527')
                return {
                  validate: (obj.enabled_status && !obj.enable_auto_sync) && ownerDomain,
                  tooltip,
                }
              },
            },
            {
              label: i18n.t('op_5'),
              action: () => {
                new this.$Manager('cloudsupplier_customers').performAction({
                  id: obj.cloudaccount_id,
                  action: 'retry-create',
                })
              },
              meta: () => {
                return {
                  validate: obj.status === 'create_failed',
                }
              },
            },
            // {
            //   label: i18n.t('scope.text_576'),
            //   action: obj => {
            //     this.createDialog('BindGoogleEmailDialog', {
            //       data: [obj],
            //       onManager: this.onManager,
            //       refresh: this.refresh,
            //     })
            //   },
            //   meta: (obj) => {
            //     return {
            //       validate: obj.provider && obj.provider.toLowerCase() === 'google' && obj.status === 'available',
            //     }
            //   },
            // },
            {
              label: i18n.t('common_29'),
              action: async (obj) => {
                this.createDialog('UpdatePaidCurrencyDialog', {
                  data: [obj],
                  refresh: this.refresh,
                })
              },
              meta: (obj) => {
                if (obj.billing_subscription_id) return { validate: true }
                return {
                  validate: false,
                }
              },
            },
          ])
        },
      },
    ]
  },
  methods: {
    syncPolicy (item) {
      let tooltip
      const items = changeToArr(item)
      if (!items.length) return { validate: false }
      const enabledValid = items.every(obj => {
        if (!obj.enabled_status) {
          tooltip = i18n.t('scope.text_526')
          return false
        }
        return true
      })
      const autoSyncValid = items.every(obj => {
        if (obj.enable_auto_sync) {
          tooltip = i18n.t('scope.text_527')
          return false
        }
        return true
      })
      const ownerDomain = this.$store.getters.isAdminMode | items.every(obj => obj.domain_id === this.$store.getters.userInfo.projectDomainId)
      return {
        validate: enabledValid && autoSyncValid && ownerDomain,
        tooltip,
      }
    },
    setAutoSyncPolicy (item, ownerDomain) {
      let tooltip
      const items = changeToArr(item)
      if (!items.length) return { validate: false }
      const enabledValid = items.every(obj => {
        if (!obj.enabled_status) {
          tooltip = i18n.t('scope.text_526')
          return false
        }
        return true
      })
      return {
        validate: enabledValid && ownerDomain,
        tooltip,
      }
    },
  },
}
